module.exports = __webpack_public_path__ + "img/40_38_031_610.0593d807.jpg";